import { render, staticRenderFns } from "./GStatisticsTrendAnalysisChart.vue?vue&type=template&id=a88451c4&scoped=true&"
import script from "./GStatisticsTrendAnalysisChart.vue?vue&type=script&lang=ts&"
export * from "./GStatisticsTrendAnalysisChart.vue?vue&type=script&lang=ts&"
import style0 from "./GStatisticsTrendAnalysisChart.vue?vue&type=style&index=0&id=a88451c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88451c4",
  null
  
)

export default component.exports